import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-storyblok-image';
import SbEditable from 'storyblok-react';

//

const getField = (content, hyphenName, fallbackName) =>
  content?.[hyphenName] || content?.[fallbackName];

const renderDescription = (description) =>
  description
    .split('\n')
    .filter((line) => line.trim())
    .map((line) => <p key={line}>{line}</p>);

const FigmaPage = ({ content }) => {
  const header = getField(content, 'figma-header', 'figmaHeader');
  const buttonText = getField(content, 'figma-btn-success', 'figmaBtnSuccess');
  const description = getField(
    content,
    'figma-description',
    'figmaDescription'
  );
  const image = getField(content, 'figma-image', 'figmaImage');
  const hasImage = image?.filename;
  const fluidProps = hasImage
    ? getFluidGatsbyImage(image.filename, {
        maxWidth: 520,
        maxHeight: 640,
      })
    : null;

  return (
    <SbEditable content={content}>
      <FigmaPageWrap>
        <div className="figma-page__inner">
          {header && <h1>{header}</h1>}

          {buttonText && (
            <button className="figma-page__button" type="button">
              {buttonText}
            </button>
          )}

          {fluidProps && (
            <div className="figma-page__image">
              <Img fluid={fluidProps} alt={image.alt || header || ''} />
            </div>
          )}

          {description && (
            <div className="figma-page__description">
              {renderDescription(description)}
            </div>
          )}
        </div>
      </FigmaPageWrap>
    </SbEditable>
  );
};

export default FigmaPage;

const FigmaPageWrap = styled.section`
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 8rem 2rem 6rem;
  background: #fffefc;
  color: #111;

  .figma-page__inner {
    width: 100%;
    max-width: 54rem;
    text-align: center;
  }

  h1 {
    max-width: 42rem;
    margin: 0 auto;
    font-family: var(--font-serif);
    font-size: 3rem;
    font-weight: 400;
    line-height: 1.12;
  }

  .figma-page__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 2.4rem;
    margin-top: 1.8rem;
    padding: 0.5rem 1.2rem;
    border: 0;
    border-radius: 0.2rem;
    background: #5f8d2a;
    color: #fff;
    font-family: var(--font-sans);
    font-size: 1rem;
    line-height: 1;
    cursor: pointer;
  }

  .figma-page__image {
    width: 100%;
    max-width: 24rem;
    margin: 5rem auto 0;
  }

  .figma-page__description {
    max-width: 42rem;
    margin: 6rem auto 0;
    font-family: var(--font-sans);
    font-size: 1.1rem;
    line-height: 1.45;
    text-align: left;
  }

  .figma-page__description p {
    margin: 0;
  }

  .figma-page__description p + p {
    margin-top: 2rem;
  }

  @media (min-width: 768px) {
    padding-top: 10rem;

    h1 {
      font-size: 3.6rem;
    }

    .figma-page__image {
      max-width: 25.6rem;
    }
  }
`;

FigmaPage.propTypes = {
  content: PropTypes.shape({
    'figma-header': PropTypes.string,
    'figma-btn-success': PropTypes.string,
    'figma-description': PropTypes.string,
    'figma-image': PropTypes.object,
    figmaHeader: PropTypes.string,
    figmaBtnSuccess: PropTypes.string,
    figmaDescription: PropTypes.string,
    figmaImage: PropTypes.object,
  }),
};

FigmaPage.defaultProps = {
  content: {},
};
